import IListFilter from "@/models/IListFilter";
import {ReportState} from "@/helpers/constants";
import {isEmpty} from "@/helpers/functions_asi";

export default class ReportListFilter implements IListFilter {

	private static readonly defaultStateFilter = [];
	private readonly defaultStateFilterInternal: ReportState[] = [];

	public fulltext: string | null = null;

	public states: ReportState[] = [];
	public orderCompanyName: string | null = null;
	public orderCompanyId: string | null = null;
	public driverCompanyName: string | null = null;
	public driverCompanyId: string | null = null;
	public userName: string | null = null;
	public userId: string | null = null;
	public orderName: string | null = null;
	public orderId: string | null = null;
	public billName: string | null = null;
	public billId: string | null = null;
	public dateFrom: string | null = null;
	public dateTo: string | null = null;
	public licensePlate: string | null = null;
	public notesDriver: string | null = null;
	public notesAdministration: string | null = null;

	public constructor(defaultStateFilter: ReportState[] | null = null) {
		this.defaultStateFilterInternal = defaultStateFilter === null ? ReportListFilter.defaultStateFilter : defaultStateFilter;
		this.states = this.defaultStateFilterInternal;
	}

	public clear(): void {
		this.fulltext = null;
		this.states = this.defaultStateFilterInternal;
		this.orderCompanyName = null;
		this.orderCompanyId = null;
		this.driverCompanyName = null;
		this.driverCompanyId = null;
		this.userName = null;
		this.userId = null;
		this.orderName = null;
		this.orderId = null;
		this.billName = null;
		this.billId = null;
		this.dateFrom = null;
		this.dateTo = null;
		this.licensePlate = null;
		this.notesDriver = null;
		this.notesAdministration = null;
	}

	public hasFilter(): boolean {
		if (this.states.length !== this.defaultStateFilterInternal.length) {
			return true;
		}

		for (let i = 0; i < this.states.length; i++) {
			if (!this.defaultStateFilterInternal.includes(this.states[i])) {
				return true;
			}
		}

		return !isEmpty(this.fulltext)
			|| !isEmpty(this.orderCompanyName)
			|| !isEmpty(this.driverCompanyName)
			|| !isEmpty(this.userName)
			|| !isEmpty(this.orderName)
			|| !isEmpty(this.billName)
			|| !isEmpty(this.dateFrom) || !isEmpty(this.dateTo)
			|| !isEmpty(this.licensePlate)
			|| !isEmpty(this.notesDriver) || !isEmpty(this.notesAdministration);
	}

}
